import PropTypes from "prop-types";
import {connect} from "react-redux";

import {
  getBalanceDueAmount,
  getFinancedAmount
} from "../../priceWorksheet/discountFinanceFunctions";
import {getPriceWithCurrency} from "../../../misc/helpers";

const ContractsPopupFieldsFinance = (props) => {
  const {store, field} = props;

  switch (field?.name) {
    case "financeAmount":
    case "financedAmount":
      return getPriceWithCurrency(store.fabricatorState.settings, getFinancedAmount(store));
    case "balanceDue":
    // case "financeAmount":
      return getPriceWithCurrency(store.fabricatorState.settings, getBalanceDueAmount(store));
    default:
      return null
  }
};

// ["costcoExclusiveMembers"] = quoteFeatures.Any(f => f.Group == "Costco Member Benefits" && f.Name.Contains("Costco Executive Members") && f.Quantity > 0) ? costco2Precents.ToString("0.00") : "0.00",
//   ["costcoShopCard"] = costcoShopCard.ToString("0.00"),
//   ["costcoCitiVisa"] = quoteFeatures.Any(f => f.Group == "Costco Member Benefits" && f.Name.Contains("Costco Citi Visa Cardholder") && f.Quantity > 0) ? costco2Precents.ToString("0.00") : "0.00",

ContractsPopupFieldsFinance.propTypes = {
  field: PropTypes.object,
  fieldCoords: PropTypes.object,
  totalPrice: PropTypes.object,
}

const mapStateToProps = (store) => {
  return {store}
};

export default connect(mapStateToProps)(ContractsPopupFieldsFinance)
